import {
  APP_URL_CONTRACT,
  CONTRACTEMPLOYEE,
  EMPLOYEE,
  REPRESENTATIONEXPENSE,
} from "../constants";
import HttpClient from "../services/HttpClient";
const headers = { "Content-Type": "application/json" };

export const getemployees = (filters, paginador) => {
  return new Promise((resolve) => {
    HttpClient.post(
      `${APP_URL_CONTRACT}/employee/criteria/?page=${paginador.page}&size=${paginador.size}&order=${paginador.order}&columnOrder=${paginador.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error?.response);
      });
  });
};

export const getCertificateId = (id) => {
  return new Promise((resolve) => {
    HttpClient.get(
      `${APP_URL_CONTRACT}${EMPLOYEE}${id}/work-certificate`,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error?.response);
      });
  });
};

export const downloadCertificate = (id) => {
  return new Promise((resolve) => {
    HttpClient.get(
      `${APP_URL_CONTRACT}${EMPLOYEE}work-certificate/${id}/download-report`,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error?.response);
      });
  });
};

export const getContractByEmployee = (employeeId, bindingtype, filters) => {
  return new Promise((resolve) => {
    HttpClient.post(
      `${APP_URL_CONTRACT}${CONTRACTEMPLOYEE}${employeeId}/binding-type/${bindingtype}`,
      filters,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error?.response);
      });
  });
};

export const generateCertificate = (employeeId, body) => {
  return new Promise((resolve) => {
    HttpClient.post(
      `${APP_URL_CONTRACT}${EMPLOYEE}${employeeId}/work-certificate`,
      body,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error?.response);
      });
  });
};

// get representation expense
export const getRepresentationExpense = (id) => {
  return new Promise((resolve) => {
    HttpClient.get(`${APP_URL_CONTRACT}${REPRESENTATIONEXPENSE}${id}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((e) => {
        resolve(e?.response);
      });
  });
};
